export default "__VITE_ASSET__Cw98vukH__"